import { Base, Component, Prop } from '@/vue-property-decorator'
import { GameCardCommonProps } from '../common.type'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { useMainStore } from '@/store/index'
import BoxCut from '../components/boxCut'
import FavoriteIcon from '../components/favoriteIconHK'
import LabelGameStatus from '../components/labelGameStatus'
import MaskMaintain from '../components/maskMaintain'
import style from './style.module.scss'
export interface State {
  /** 主背景图是否加载成功 */
  mainContentLoad: boolean
}
export interface Props extends GameCardCommonProps {
  /** 次级名称 */
  secondaryName?: string
  /** 尺寸大小 */
  mySize?: 'default' | 'small'
}
/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<verticalBottomNameHK>({
  name: 'verticalBottomNameHK'
})
export default class verticalBottomNameHK extends Base<State, Props> {
  @Prop()
  private status!: Props['status']
  @Prop()
  private isFavorited!: Props['isFavorited']
  @Prop()
  private gameName!: Props['gameName']
  @Prop()
  private secondaryName!: Props['secondaryName']
  @Prop()
  private imgUrl!: Props['imgUrl']
  @Prop()
  private logoUrl!: Props['logoUrl']
  @Prop({ default: false })
  private isMaintain!: Props['isMaintain']
  @Prop({ default: false })
  private isCompleteImage!: Props['isCompleteImage']
  @Prop({ default: true })
  private isShowFavorited!: Props['isShowFavorited']
  @Prop({ default: 'default' })
  private mySize!: Required<Props>['mySize']

  state: State = {
    mainContentLoad: false
  }

  /** 游戏名称布局的class */
  get gameNameLayoutClass() {
    const { logoUrl, secondaryName } = this
    if (logoUrl) return 'layout-left-right'
    if (secondaryName) return 'layout-top-bottom'
    return 'layout-top-bottom'
  }

  /** 左上角的角度 */
  get boxCutRadius() {
    const { isWeb } = useMainStore()
    const { status } = this
    // 整体角度裁剪,分了四种情况,主要考虑的就是左上角兼容status的状况
    const map = new Map([
      [isWeb && Boolean(status), '0.1rem 0.14rem 0.14rem 0.14rem'],
      [isWeb && !Boolean(status), '0.14rem'],
      [!isWeb && Boolean(status), '0.14rem 0.2rem 0.2rem 0.2rem'],
      [!isWeb && !Boolean(status), '0.2rem']
    ])
    return map.get(true)
  }

  /** 渲染游戏名称,上下结构 */
  private renderGameNameTopBottom() {
    const { gameName, secondaryName } = this
    return (
      <div
        class={{
          [style['name-box']]: true,
          [style['layout-top-bottom']]: true
        }}
      >
        <p class={style['top-name']}>{gameName}</p>
        <p class={style['bottom-name']}>{secondaryName}</p>
      </div>
    )
  }

  render() {
    const {
      isMaintain,
      imgUrl,
      isFavorited,
      isCompleteImage,
      isShowFavorited,
      mySize
    } = this
    const { status, boxCutRadius } = this
    // const { isWeb } = useMainStore()
    return (
      <div class={style['vertical-bottom-name']}>
        <my-img
          options={{
            type: 'div'
          }}
          src=""
          class={{
            [style['item-main']]: true,
            [style[`size-${mySize}`]]: true
          }}
          onClick={() => this.$emit('click')}
        >
          <BoxCut
            cutStyle={{
              borderRadius: boxCutRadius
            }}
          >
            {/* 背景图 */}
            <div
              class={{
                [style['default-img-box']]: true,
                'default-img-load':
                  !this.state.mainContentLoad && !!isCompleteImage
              }}
            >
              <icon-sprite sprite={createSvgSprite('img_mryx_card')} />
            </div>
            {/* 主体内容图片 */}
            <my-img
              class={{ [style['main-content']]: true }}
              options={{ type: 'div' }}
              src={imgUrl as string}
              onLoadError={() => {
                this.setState({
                  mainContentLoad: true
                })
              }}
            >
              {/* 如果是完整的一张图片,则不用渲染游戏名称的内容了 */}
              {!isCompleteImage && this.renderGameNameTopBottom()}
            </my-img>
            <my-img
              class={style['border-img']}
              src={`/lobby_asset/{layout}-{bg}-{skin}/web/home/img_dt_border18.png`}
              options={{ type: 'div' }}
            ></my-img>
            <template slot="cutSuspense">
              {/* 游戏状态标签 */}
              {status && <LabelGameStatus />}
              {/* 鼠标悬浮覆盖层 */}
              {!isMaintain && (
                <my-img
                  class={style['play-img']}
                  options={{ type: 'div' }}
                  src={`/lobby_asset/{layout}-{bg}-{skin}/web/home/img_play.png`}
                ></my-img>
              )}
              {/* 维护状态悬浮层 */}
              {isMaintain && <MaskMaintain />}
            </template>
            {/* unCut插槽中的元素,不会被overflow:hidden裁剪 */}
            <template slot="unCutSuspense">
              {isShowFavorited && (
                <FavoriteIcon
                  type={'block'}
                  isFavorited={isFavorited}
                  onClick={($event) => this.$emit('clickFavorIcon', $event)}
                />
              )}
            </template>
          </BoxCut>
        </my-img>
      </div>
    )
  }
}
